/**
 * Created by rickborst on 01/03/2017.
 */

import Session from 'models/session';

import {convertForLocalStorage, convertFromLocalStorage} from '../adapters/session';

import {getInstance as getStorageManager} from 'storage/manager';

const storageManager = getStorageManager(),
    storageKey = 'session',
    storagePeriod = 1000 * 60 * 60 * 24 * 30; // A month

let sessionManager;

class SessionManager {

    /**
     * Returns whether or not a stored session has expired.
     *
     * @param {Object} storedSession - Stored session.
     * @returns {boolean} True or false.
     * @private
     */
    _hasExpired (storedSession) {

        return (Date.now() - storedSession.storageTimestamp >= storagePeriod);
    }

    /**
     * Loads any stored session.
     *
     * @returns {Object|null} Stored session or null.
     */
    getStoredSession () {
        let data = convertFromLocalStorage.call(this, storageManager.read(storageKey));

        if (data && this._hasExpired(data)) {

            this.clearStoredSession();
            return null;
        }

        return data;
    }

    /**
     * Updates any stored session.
     *
     * @param {Object} session - Session to update.
     */
    updateStoredSession (session) {

        storageManager.store(storageKey, convertForLocalStorage.call(this, session));
    }

    /**
     * Clears any stored session.
     */
    clearStoredSession () {

        storageManager.clear(storageKey);
    }
}

sessionManager = new SessionManager();

/**
 * Returns a session, either empty or stored if one is available.
 *
 * @returns {Promise} Session promise.
 */
export function getSession () {
    let storedSession = sessionManager.getStoredSession() || {};

    return Promise.resolve(new Session(storedSession));
}

/**
 * Updates the currently stored session.
 *
 * @param {Object} session - Session to be stored.
 * @returns {Promise} Update session promise.
 */
export function updateSession (session) {
    sessionManager.updateStoredSession(session);

    return Promise.resolve(session);
}

/**
 * Clears any stored session.
 *
 * @returns {Promise} Clear session promise.
 */
export function clearSession () {

    sessionManager.clearStoredSession();

    return Promise.resolve(new Session());
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/session.js